import { useSelector, useDispatch } from 'react-redux';
import FJVideoRemoveBgRight from '../view/FJVideoRemoveBgRight';
import { useEffect, memo } from 'react';
import FJActionVideoRemoveBg from '../../../../redux/action/FJActionVideoRemoveBg';
import useLocalStore from '../../../../hooks/useLocalStore';

const FJVideoRemoveBgRightContainer = memo(() => {
    useLocalStore();
    const dispatch = useDispatch();
    const editVideoInfo = useSelector(state => state.videoBgRemover.editVideoInfo);
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);
    const customRemoverStep = useSelector(state => state.videoBgRemover.customRemoverStep);
    const customRemoverStatus = useSelector(state => state.videoBgRemover.customRemoverStatus);
    const curMenuIndex = useSelector(state => state.videoBgRemover.curMenuIndex);
    const autoEditVideoInfo = useSelector(state => state.videoBgRemover.autoEditVideoInfo);
    const autoRemoverStatus = useSelector(state => state.videoBgRemover.autoRemoverStatus);

    useEffect(() => {
        dispatch(FJActionVideoRemoveBg.pauseAction());
    }, [dispatch, headerTabIndex]);

    return (
        <FJVideoRemoveBgRight
            editVideoInfo={editVideoInfo}
            headerTabIndex={headerTabIndex}
            customRemoverStep={customRemoverStep}
            customRemoverStatus={customRemoverStatus}
            curMenuIndex={curMenuIndex}
            autoEditVideoInfo={autoEditVideoInfo}
            autoRemoverStatus={autoRemoverStatus}
        />
    );
});

FJVideoRemoveBgRightContainer.displayName = 'FJVideoRemoveBgRightContainer';
export default FJVideoRemoveBgRightContainer;
